module.exports = __webpack_public_path__ + "static/media/EW1.0d734532.png";